import { formatDate } from './formatDate';

export function getPublicHolidaysByDateRange(publicHolidays, startDate, endDate) {
  // Convert the start and end dates to UTC timestamps for comparison
  const startTimestamp = startDate.getTime();
  const endTimestamp = endDate.getTime();

  // Filter the public holidays based on the date range
  const filteredHolidays = publicHolidays.filter((holiday) => {
    const holidayTimestamp = new Date(holiday.date).getTime();
    return holidayTimestamp >= startTimestamp && holidayTimestamp <= endTimestamp;
  });

  return filteredHolidays;
}

export function countSchoolDays(start, end, terms, holidays) {
  let returnValue = {
    exclude: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    include: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    publicHolidays: [],
    schoolHolidays: [],
  };

  let startDate = start;
  let endDate = end;

  const publicHolidaysInRange = getPublicHolidaysByDateRange(holidays, start, end);

  for (
    let currentDate = startDate; //set current date to start
    currentDate.setHours(0, 0, 0, 0) <= endDate.setHours(0, 0, 0, 0); //run while current date is <= end date
    currentDate.setDate(currentDate.getDate() + 1) //on each iteration, set current date to the day after
  ) {
    //check if current date is a weekday
    const day = currentDate.getDay();

    //if a weekend, go to the next iteration of the loop
    if (day === 0 || day === 6) {
      continue;
    }

    let isSchoolDay = false;

    //check if day is a school day
    for (let term of terms) {
      //if the current date is within this term

      //dates appear to be zero based, so add 1 here
      let termStartDate = new Date(term.start_date);
      termStartDate.setDate(termStartDate + 1);

      let termEndDate = new Date(term.end_date);
      termEndDate.setDate(termEndDate + 1);
      //new Date(term.start_date)

      if (
        currentDate.setHours(0, 0, 0, 0) >= new Date(term.start_date).setHours(0, 0, 0, 0) && //current >= start date
        currentDate.setHours(0, 0, 0, 0) <= new Date(term.end_date).setHours(0, 0, 0, 0)
      ) {
        //current <= end date
        isSchoolDay = true;
        break; // break out of the loop
      }
    } //Dayjs

    //if not a term day it is a school holiday, save it to school holiday, go to the next day
    if (!isSchoolDay) {
      //add it to the school holidays
      returnValue.schoolHolidays.push({ date: formatDate(currentDate), day: day });
      continue;
    }

    //check if day is a public holiday
    let isPublicHoliday = false;
    for (let publicHoliday of publicHolidaysInRange) {
      if (currentDate.setHours(0, 0, 0, 0) === new Date(publicHoliday.date).setHours(0, 0, 0, 0)) {
        isPublicHoliday = true;
        //add the public holiday
        returnValue.publicHolidays.push({ date: formatDate(currentDate), day: day });
        break; //break out of loop
      }
    }

    //if a normal school day, add to the count of school days
    if (isSchoolDay && !isPublicHoliday) {
      returnValue.include[day] += 1;
    }

    //if a normal school day, but a public holiday, it's an excluded day
    if (isSchoolDay && isPublicHoliday) {
      returnValue.exclude[day] += 1;
    }
  }
  return returnValue;
}
